import { createContext } from 'react';

const DrawerStateContext = createContext(null);
export default DrawerStateContext;
